import React, { useEffect } from 'react';
import { Button } from 'antd';
import { LeftOutlined } from '@ant-design/icons';

import history from '../../core/utils/history';
import Main from '../../components/layout/Main';
import LoginForm from '../../components/Forms/LoginForm';
import SEO from '../../components/SEO';
import { PAGE_SEO_CONFIG } from '../../components/SEO/seoConfig';
import useLanguage from '../../core/language/useLanguage';

import useUser from '../../core/user/useUser';
import { getTranslation } from '../../core/utils/helpers';

import './login.scss';

const Login = () => {
    const { language } = useLanguage();

    const { user } = useUser();

    const { getLanguagesRequest } = useLanguage();

    useEffect(() => {
        getLanguagesRequest();

        if (user?.isLoggedIn === true) {
            history.push('/dashboard');
        }
    }, []);

    // const toolbar = [{ label: 'Item 1', link: '/abc', iconName: 'home' }];
    // const menu = [{ label: 'Item 1', link: '/abc', iconName: 'home', style: { fontSize: 24, color: 'red' } }];
    // const navigation = [{ label: 'Item 1', link: '/abc' }, { label: 'Item 1', link: '/abc' }];

    return (
        <>
            <SEO
                title={PAGE_SEO_CONFIG.home.title}
                description={PAGE_SEO_CONFIG.home.description}
                url="/"
                jsonLd={{
                    '@context': 'https://schema.org',
                    '@type': 'WebSite',
                    name: 'Prakash Astrologer',
                    description: PAGE_SEO_CONFIG.home.description,
                    url: 'https://astrology.prakashastrologer.com',
                }} />
            <Main
                className="login"
                headerTitle={<div>{getTranslation(language, 'login_screen_main_title', 'Sign In')}</div>}
                menuWidth={350}
                menuPlacement="right"
                showHeader={false}
                showFooter={false}
                backLink={(
                    <Button onClick={() => console.log('Back')}>
                        <LeftOutlined />  {getTranslation(language, 'navigation_title_back', 'Back')}
                    </Button>
                )}>
                <LoginForm />
            </Main>
        </>
    );
};

export default Login;

Login.propTypes = {};
